import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import FormField from '../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../common/GridLayout";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { HeaderLayout } from './Layout';
import { LoadPanel } from 'devextreme-react/load-panel';
import axios from 'axios';
import data from '../../../assets/apiRoutes.json';
import notify from 'devextreme/ui/notify';
import { MESSAGES } from '../../../common/Messages';
import { alert, confirm } from 'devextreme/ui/dialog';
import { OM } from '../../../const/constants';
import { GetFormatedDateWithTime } from '../../../common/Utils';
import { custom } from 'devextreme/ui/dialog';
import { RecordTypes } from '../../../enum/Enum';

const Form = (props) => {
    const history = useHistory();
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const formRefs = useRef({});

    const initialFormFields = {
        RowId: '00000000-0000-0000-0000-000000000000',
        Module: OM,
        RecordType: RecordTypes.Receipt,
        CodeType: null,
        Code: null,
        Description1: '',
        Description2: '',
        Comment: null,
        PopupMessage: ''
    };

    const [formFields, setformFields] = useState(initialFormFields);

    useEffect(() => {
        if (props.id) {
            LoadData();
        }
    }, [props.id]);

    const LoadData = async () => {
        setLoadPanelVisible(true);
        try {
            const result = await axios.get(
                `${window._env_.REACT_APP_APIS}/${data.OM?.GetCodeByRowId || 'om/Codes/GetCode'}?rowId=${props.id}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    }
                }
            );

            if (result.data) {
                setformFields(result.data);
            }
        } catch (error) {
            console.error('Error loading data:', error);
            notify(
                {
                    message: MESSAGES.FETCH_ERROR || 'Error loading data',
                    width: 450,
                },
                'error',
                3000
            );
        } finally {
            setLoadPanelVisible(false);
        }
    };

    const handleFieldChange = useCallback((name, value, e) => {
        // Handle field changes if needed
    }, []);

    const handleSelectedItemChange = (name, e) => {
        // Handle selected item changes if needed
    };

    const handleFormLoad = useCallback(() => {
        // Handle form load if needed
    }, []);


    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoadPanelVisible(true);
        try {
            if (formFields.RowId === "00000000-0000-0000-0000-000000000000" || !formFields.RowId) {
                await insertCode();
            } else {
                await updateCode();
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    const insertCode = async () => {
        try {
            const url = data.OM?.InsertCode || 'om/Codes/InsertCode';

            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/${url}`,
                formFields,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    },
                }
            );

            if (response.data && (!response.data.ERRORS || response.data.ERRORS.length === 0)) {
                setformFields(prevFields => ({
                    ...prevFields,
                    RowId: response.data.ROWID,
                }));
                notify(
                    {
                        message: MESSAGES.INSERT_SUCCESS || "Code Created Successfully",
                        width: 300,
                    },
                    'success',
                    3000,
                );
            } else {
                const errors = response.data?.ERRORS || ['An error occurred'];
                const errorHtml = errors.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
        } catch (error) {
            console.error('Error inserting code:', error);
            if (error.response?.data?.ERRORS && error.response.data.ERRORS.length > 0) {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            } else {
                notify(
                    {
                        message: MESSAGES.INSERT_ERROR || "Could not create code. An error occurred",
                        width: 450,
                    },
                    'error',
                    3000,
                );
            }
        }
    };

    const updateCode = async () => {
        try {
            const url = data.OM?.UpdateCode || 'om/Codes/UpdateCode';
            const response = await axios.put(
                `${window._env_.REACT_APP_APIS}/${url}`,
                formFields,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    },
                }
            );

            if (response.data && (!response.data.ERRORS || response.data.ERRORS.length === 0)) {
                notify(
                    {
                        message: MESSAGES.UPDATE_SUCCESS || "Code Updated Successfully",
                        width: 300,
                    },
                    'success',
                    3000,
                );
            } else {
                const errors = response.data?.ERRORS || ['An error occurred'];
                const errorHtml = errors.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
        } catch (error) {
            console.error('Error updating code:', error);
            if (error.response?.data?.ERRORS && error.response.data.ERRORS.length > 0) {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            } else {
                notify(
                    {
                        message: MESSAGES.UPDATE_ERROR || "Could not update code. An error occurred",
                        width: 450,
                    },
                    'error',
                    3000,
                );
            }
        }
    };

    const handleDelete = async () => {
        if (!formFields.RowId || formFields.RowId === "00000000-0000-0000-0000-000000000000") {
            notify(
                {
                    message: "No record selected for deletion",
                    width: 300,
                },
                'warning',
                3000
            );
            return;
        }

        const confirmDelete = await confirm(MESSAGES.DELETE_CONFIRM || "Are you sure you want to delete this record?", "Delete");
        if (!confirmDelete) return;

        setLoadPanelVisible(true);
        try {
            const url = data.OM?.DeleteCode || 'om/Codes/DeleteCode';
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/${url}`,
                formFields.RowId,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    },
                }
            );

            if (response.status === 200) {
                notify(
                    {
                        message: MESSAGES.DELETE_SUCCESS || "Code Deleted Successfully",
                        width: 300,
                    },
                    'success',
                    3000,
                );
                history.push('/om/codes/descriptive-codes-data-entry-list');
            } else {
                alert(response.data?.message || MESSAGES.DELETE_ERROR || "Error deleting code", MESSAGES.ERROR || "Error");
            }
        } catch (error) {
            console.error('Error deleting code:', error);
            alert(
                error.response?.data?.message || MESSAGES.DELETE_ERROR || "Could not delete code. An error occurred",
                MESSAGES.ERROR || "Error"
            );
        } finally {
            setLoadPanelVisible(false);
        }
    };

    const handleReset = () => {
        if (props.id) {
            LoadData();
        } else {
            setformFields(initialFormFields);
        }
    };

    const handleAddNew = () => {
        setformFields(initialFormFields);
        history.push('/om/codes/descriptive-codes-data-entry-create');
    };

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, []);

    return (
        <div>
            <div className="row dataEnteryMainPage">
                <div className="col-md-12 main-page">
                    <form onSubmit={(e) => handleFormSubmit(e)}>
                    <LoadPanel
                        shadingColor="rgba(0,0,0,0.4)"
                        onHiding={hideLoadPanel}
                        visible={loadPanelVisible}
                        showIndicator={true}
                        shading={true}
                        showPane={true}
                        hideOnOutsideClick={false}
                    />
                    <Toolbar>
                        <Item location="before">
                            <div className="title">
                                <h6
                                    style={{
                                        color: window._env_.Color2
                                    }}
                                >
                                    OM Descriptive Codes
                                </h6>
                            </div>
                        </Item>
                        <Item location="after">
                            <Button
                                className="accordianButton"
                                 useSubmitBehavior={true}
                                text="Save"
                                type="default"
                            />
                        </Item>
                        <Item location="after">
                            <Button className="accordianButton" onClick={handleAddNew} text="New" type="default" />
                        </Item>
                        <Item location="after">
                            <Button className="accordianButton" onClick={handleReset} text="Reset" />
                        </Item>
                        <Item location="after">
                            <Button
                                className="accordianButton"
                                onClick={handleDelete}
                                text="Delete"
                                disabled={!formFields.RowId || formFields.RowId === "00000000-0000-0000-0000-000000000000"}
                            />
                        </Item>
                        <Item location="after">
                            <Button
                                className="accordianButton"
                                onClick={() => history.push('/om/codes/descriptive-codes-data-entry-list')}
                                text="Back"
                            />
                        </Item>
                    </Toolbar>
                    <div style={{ height: 'auto', marginBottom: 20, padding: '20px' }}>
                        <FormField
                            currrentUser={currentUser}
                            layoutId='BA75ACCB-7FD3-43D4-89E9-687BF074776B'
                            layoutName='OMDescriptiveCodesForm'
                            defaultFormSchema={HeaderLayout}
                            formFields={formFields}
                            setformFields={setformFields}
                            handleFieldValueChange={handleFieldChange}
                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                            formRefs={formRefs}
                            onFormLoad={handleFormLoad}
                            handleSelectedItemChange={handleSelectedItemChange}
                        />
                    </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(Form);
